import { Container, Row, Col } from 'react-bootstrap';
import useAccountContext from '../../authentication/hooks';

const Welcome = () => {
    const accountContext = useAccountContext();

    return (
        <Container fluid className='welcome-banner-background gs-wrapper mb-5' data-testid='welcome-banner'>
            <Container className='d-flex'>
                <Row>
                    <Col md={12} lg={9} className='welcome-message' data-testid='welcome-banner-username'>
                        <h1 id='page-title-nofocus' tabIndex={-1} className='banner-title mb-0 lh-sm'>
                            {'Welcome '}
                            {accountContext?.details && (
                                <>
                                    <br />
                                    {accountContext?.details?.givenName !== undefined && (`${accountContext?.details?.givenName}`)}
                                </>
                            )}
                        </h1>
                    </Col>
                </Row>
            </Container>
        </Container>
    );
};

export default Welcome;
